/** Пустой contentEditable часто даёт <br> или <p><br></p>. */
export function normalizeEditorHtml(html: string): string {
  const trimmed = html.trim();
  if (!trimmed) return "";

  const emptyPatterns = [
    "<br>",
    "<br/>",
    "<br />",
    "<p></p>",
    "<p><br></p>",
    "<p><br/></p>",
    "<p><br /></p>",
    "<div><br></div>",
    "<div><br/></div>",
    "<div><br /></div>",
  ];

  if (emptyPatterns.includes(trimmed)) return "";
  return html;
}

export function isEditorHtmlEmpty(html: string): boolean {
  return normalizeEditorHtml(html) === "";
}
